import React from "react";
import { withTranslation } from "react-i18next";

const ReachUs = (props) => {
  const email =
    (props.companyInformation && props.companyInformation.email) || "";
  const phone =
    (props.companyInformation && props.companyInformation.phone) || "";
  const address =
    (props.companyInformation && props.companyInformation.address) || "";
    
  return (
    <div className="reach-us-block">
      <h2>{props.t("homePage.reachUs")}</h2>
      <div className="contact-dtl">
        <div className="content-container">
          <ul>
            <li>
              <a href={`mailto:${email}`}>{email}</a>
            </li>
            <li>
              <a href={`tel:${phone}`}>{phone}</a>
            </li>
            <li>
              <a
                href={`https://www.google.com/maps?q=${address}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {address}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(ReachUs);